import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router'

import Loader from 'components/Loader/Loader'
import '../../components/Loader/Loader.scss'
import Typography from '../../components/Typography/Typography'

import hocConnect from './hocConnect'
import './PaymentVerify.scss'

const PaymentVerify = ({ verifyPaymentStart }) => {
    const intl = useIntl()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const verifyBody = {
        provider_data: Object.fromEntries(params),
    }

    const initialized = useRef(false)

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            verifyPaymentStart(verifyBody)
        }
    }, [])

    return (
        <div className="payment-verify">
            <div className="content-wrapper">
                <div className="loader-wrapper">
                    <Loader />
                </div>

                <Typography variant="h2" className={'payment-verify-text'}>
                    {intl.formatMessage({ id: 'paymentVerify.paymentIsBeingVerified' })}
                </Typography>
            </div>
        </div>
    )
}

export default hocConnect(PaymentVerify)
